import { render, staticRenderFns } from "./PictureQuestion.vue?vue&type=template&id=01b6cdf4&scoped=true&"
import script from "./PictureQuestion.vue?vue&type=script&lang=js&"
export * from "./PictureQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PictureQuestion.vue?vue&type=style&index=0&id=01b6cdf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6cdf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
